import { Typography } from "@circle-react-uikit/Typography";
import { PasswordInput } from "@circleco/compass/components/PasswordInput";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

const LOCALE_ROOT =
  "paywall_checkout.form.email_verification_states.password_state";

interface PasswordFormSectionProps {
  hasError: boolean;
  isSubmitting: boolean;
  isSubmittingForgotPassword: boolean;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  password: string;
  shouldShowActions: boolean;
}

export const PasswordFormSection = ({
  password,
  hasError,
  isSubmitting,
  isSubmittingForgotPassword,
  shouldShowActions,
  onPasswordChange,
  onKeyDown,
  onSubmit,
}: PasswordFormSectionProps) => (
  <div className="flex flex-col gap-4">
    <Typography.TitleSm weight="bold" size="text-md">
      {t([LOCALE_ROOT, "sign_in_to_your_account"])}
    </Typography.TitleSm>

    <div className="flex flex-col gap-5">
      <PasswordInput
        label={t("paywall_checkout.form.fields.password")}
        value={password}
        onChange={onPasswordChange}
        onKeyDown={onKeyDown}
        disabled={isSubmitting || isSubmittingForgotPassword}
        invalid={hasError}
        autoFocus
        autoComplete="current-password"
      />

      {shouldShowActions && (
        <Button
          type="button"
          variant="circle"
          disabled={
            isSubmitting || isSubmittingForgotPassword || !password.trim()
          }
          onClick={onSubmit}
          className="self-start !text-sm font-medium"
          data-testid="paywall-checkout-password-sign-in-button"
        >
          {t([LOCALE_ROOT, "sign_in"])}
        </Button>
      )}
    </div>
  </div>
);
